import React from "react";
import {
    Radio,
    FormControlLabel,
    RadioGroup as MuiRadioGroup
} from "@mui/material";

export type RadioOption = {
    value: string;
    label: React.ReactNode;
};

export interface RadioGroupProps {
    value: string;
    options: RadioOption[];
    onChange: (value: string) => void;
}

export function RadioGroup(props: RadioGroupProps) {
    const {value, options, onChange} = props;

    return (
        <MuiRadioGroup value={value}
                       onChange={(e) => onChange(e.target.value)}>
            {options.map((opt: RadioOption) => (
                <FormControlLabel
                    key={opt.value}
                    value={opt.value}
                    control={<Radio/>}
                    label={opt.label}/>
            ))}
        </MuiRadioGroup>
    );
}